// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAZ4b2wPNVMMsXoXhPSw7QVu-sOUYGMSOw",
  authDomain: "orb-ai-project.firebaseapp.com",
  projectId: "orb-ai-project",
  storageBucket: "orb-ai-project.firebasestorage.app",
  messagingSenderId: "773224957069",
  appId: "1:773224957069:web:2c0634dc4c0932cad94ec4",
  measurementId: "G-GZJM34VKY7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);